import { render, staticRenderFns } from "./editComplaint.vue?vue&type=template&id=23ccb895"
import script from "./editComplaint.vue?vue&type=script&lang=js"
export * from "./editComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports